<template>
  <div class="content-wrapper">
    <div class="main-content">
      <header class="main-header">
        <h1>Bakir Hamidovic</h1>
        <div class="header-text">
          <p>I am a <b>Computer Engineer, Scientific Researcher, and Programmer</b> who seeks to push technology to its limits by developing inventive devices and a wide range of scientific research.</p>
          <p>I specialize in applying computational and artificial intelligence to various research fields, including neural research, robotics, security, electromagnetism, and biology.</p>
        </div>
        <div class="social-links">
          <a href="https://www.linkedin.com/in/bakir-hamidovic/" target="_blank" rel="noopener noreferrer" title="LinkedIn"><i class="fab fa-linkedin"></i></a>
          <a href="https://github.com/habakir" target="_blank" rel="noopener noreferrer" title="Github"><i class="fab fa-github"></i></a>
          <a href="mailto:bakirhamidovic@outlook.com" title="Send E-mail"><i class="fas fa-envelope"></i></a>
          <a href="/Bakir_Hamidovic_CV.pdf" target="_blank" rel="noopener noreferrer" title="Download Resume"><i class="fas fa-file-pdf"></i></a>
        </div>
      </header>
    </div>
    <footer>
      © 2024 Bakir Hamidovic
    </footer>
</div>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css';
import { VueMetaPlugin } from 'vue-meta';

export default {
  name: 'HomePage',
  metaInfo: {
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0',
      },
    ],
  },
};
</script>

<style scoped>
.main-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  padding-top: 0;
  box-sizing: border-box;
}

.main-header {
  text-align: center;
  max-width: 800px;
  margin-top: 0;
}

.main-header h1 {
  font-size: 3.5rem;
  color: #007bff;
  margin-bottom: 10px;
}

.header-text {
  text-align: justify;
}

.header-text p {
  font-size: 1.4rem;
  color: #333;
  line-height: 1.6;
}

.social-links {
  margin-top: 20px;
}

.social-links a {
  margin: 0 10px;
  color: #333;
  text-decoration: none;
  font-size: 24px;
}

.social-links a:hover {
  color: #007bff;
  transition: color 0.3s;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 75vh; /* This helps to ensure the footer can be at the bottom of the viewport */
  position: relative;
}

footer {
  position: relative; /* Change to relative if previously absolute to avoid overlapping */
  width: 100%;
  padding: 10px 0;
  text-align: center;
}

@media (max-width: 600px) {
  .main-header h1 {
    font-size: 2rem;
  }

  .header-text p {
    font-size: 1rem;
    text-align: center; 
  }
}

</style>
